import { createClient } from '@/lib/supabase/client';

export const supabase = createClient();

export interface IRLObservation {
  id?: string;
  title: string;
  city: string;
  encounter_observations: string[];
  q_is: string;
  q_what: string;
  q_when: string;
  selected_names: string[];
  name_roles: Record<string, string>;
  process_name: string;
  process_steps: string[];
  zahir: string;
  batin: string;
  haqq: string;
  amanah: string;
  mrg_bridges: string[];
  variant: string;
  status?: string;
  created_at?: string;
}

export async function submitIRLObservation(obs: IRLObservation): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from('irl_observations')
      .insert([obs]);
    if (error) throw error;
    return { success: true };
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Unknown error';
    return { success: false, error: message };
  }
}
